import React from "react";
import ReactDOM from "react-dom";
import ShowLogoutModal from "./index";

export default async function renderLogoutModal({
  target = "modal-container",
  ...rest
} = {}) {
  const domTarget = document.getElementById(target);
  if (domTarget) {
    ReactDOM.render(<ShowLogoutModal {...rest} />, domTarget);
  }
}
